import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "envio-search" }
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = {
  key: 1,
  class: "no-results"
}

import { computed, ref, watch } from 'vue';
import { useEnviosStore } from '@/stores/useEnvioStore';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvioSearchComponent',
  setup(__props) {

const envioStore = useEnviosStore();
const { sortedEnvios, loading, error } = storeToRefs(envioStore);
const searchTerm = ref('');

// Debounce para búsqueda
let searchTimeout: number;

const handleSearch = () => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    envioStore.setSearchTerm(searchTerm.value);
  }, 300);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
        placeholder: "Buscar por expendeduría, máquina o descripción...",
        onInput: handleSearch,
        class: "search-input"
      }, null, 544), [
        [_vModelText, searchTerm.value]
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "⌛"))
        : _createCommentVNode("", true)
    ]),
    (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    (!_unref(loading) && _unref(sortedEnvios).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No se encontraron envios "))
      : _createCommentVNode("", true)
  ]))
}
}

})